module.exports = __webpack_public_path__ + "static/social-image-baa649fb17aacb201c021ad707f1aa88.png";